export const keyValueInTextMatcher = (key: string) => new RegExp(key + '="([^"]+)"'); // it will match value1 inside the following text: 'Some random text error="value1" more text' for key="error"
export const urlQueryParamMatcher = (key: string) => new RegExp('(?<=' + key + '=)[^&]*');
